// // import React, { useEffect } from "react";
// // import { useNavigate, useParams } from "react-router-dom";
// // import styles from "./OrderList.module.css";

// // import { PAGE_SIZES } from "./OrderListFile/constants";
// // import { useOrdersManager } from "./OrderListFile/useOrdersManager";
// // import OrderRow from "./OrderListFile/OrderRow";

// // export default function OrderList() {
// //   const mgr = useOrdersManager(PAGE_SIZES[0]);

// //   return (
// //     <div className={styles.page}>
// //       {/* TOOLBAR (в цьому файлі, без окремого компоненту) */}
// //       <div className={styles.toolbar}>
// //         <h2 className={styles.title}>Замовлення</h2>

// //         <div className={styles.controls}>
// //           <label className={styles.control}>
// //             <span>Період: з</span>
// //             <input
// //               type="date"
// //               value={mgr.dateFrom}
// //               onChange={(e) => mgr.setDateFrom(e.target.value)}
// //               className={styles.input}
// //             />
// //           </label>

// //           <label className={styles.control}>
// //             <span>до</span>
// //             <input
// //               type="date"
// //               value={mgr.dateTo}
// //               onChange={(e) => mgr.setDateTo(e.target.value)}
// //               className={styles.input}
// //             />
// //           </label>

// //           <label className={styles.control}>
// //             <span>Дата:</span>
// //             <select
// //               value={mgr.sortDir}
// //               onChange={(e) => mgr.setSortDir(e.target.value)}
// //               className={styles.select}
// //             >
// //               <option value="desc">спадання (нові зверху)</option>
// //               <option value="asc">зростання (старі зверху)</option>
// //             </select>
// //           </label>

// //           <label className={styles.control}>
// //             <span>Статус вгорі:</span>
// //             <select
// //               value={mgr.statusPin}
// //               onChange={(e) => mgr.setStatusPin(e.target.value)}
// //               className={styles.select}
// //             >
// //               <option value="Усі">Усі</option>
// //               {mgr.STATUS_OPTIONS.map((s) => (
// //                 <option key={s} value={s}>
// //                   {s}
// //                 </option>
// //               ))}
// //             </select>
// //           </label>

// //           <label className={styles.controlCheck}>
// //             <input
// //               type="checkbox"
// //               checked={mgr.statusOnly}
// //               onChange={(e) => mgr.setStatusOnly(e.target.checked)}
// //             />
// //             <span>Показувати лише цей статус</span>
// //           </label>

// //           <label className={styles.control}>
// //             <span>На сторінці:</span>
// //             <select
// //               value={mgr.pageSize}
// //               onChange={(e) => mgr.setPageSize(Number(e.target.value))}
// //               className={styles.select}
// //             >
// //               {PAGE_SIZES.map((n) => (
// //                 <option key={n} value={n}>
// //                   {n}
// //                 </option>
// //               ))}
// //             </select>
// //           </label>
// //         </div>
// //       </div>

// //       {/* TABLE */}
// //       <div className={styles.tableWrap}>
// //         <table className={styles.table}>
// //           <thead>
// //             <tr>
// //               <th className={styles.colCheck}></th>
// //               <th>Дата створення</th>
// //               <th>ID</th>
// //               <th>Покупець</th>
// //               <th>Статус</th>
// //               <th>Оплата</th>
// //               <th>Рахунок</th>
// //               <th>Оплачено</th>
// //               <th>Скасовано</th>
// //               <th className={styles.colSum}>Сума</th>
// //               <th>Позиції</th>
// //             </tr>
// //           </thead>

// //           <tbody>
// //             {mgr.paged.map((row) => {
// //               const id = row.order.id;
// //               const isOpen = !!mgr.expanded[id];

// //               return (
// //                 <OrderRow
// //                   key={id}
// //                   styles={styles}
// //                   row={row}
// //                   isOpen={isOpen}
// //                   toggleExpand={mgr.toggleExpand}
// //                   editingStatusId={mgr.editingStatusId}
// //                   statusDraft={mgr.statusDraft}
// //                   setStatusDraft={mgr.setStatusDraft}
// //                   beginEditStatus={mgr.beginEditStatus}
// //                   saveStatus={mgr.saveStatus}
// //                   onStatusKey={mgr.onStatusKey}
// //                   statusOptions={mgr.STATUS_OPTIONS}
// //                   editingTtnId={mgr.editingTtnId}
// //                   ttnDraft={mgr.ttnDraft}
// //                   setTtnDraft={mgr.setTtnDraft}
// //                   beginEditTTN={mgr.beginEditTTN}
// //                   saveTTN={mgr.saveTTN}
// //                   saveTTNAndSetStatus={mgr.saveTTNAndSetStatus}
// //                   cancelEditTTN={mgr.cancelEditTTN}
// //                   onTtnKey={mgr.onTtnKey}
// //                   editingItemsId={mgr.editingItemsId}
// //                   itemsDraft={mgr.itemsDraft}
// //                   newPid={mgr.newPid}
// //                   setNewPid={mgr.setNewPid}
// //                   newQty={mgr.newQty}
// //                   setNewQty={mgr.setNewQty}
// //                   savingItems={mgr.savingItems}
// //                   beginEditItems={mgr.beginEditItems}
// //                   cancelEditItems={mgr.cancelEditItems}
// //                   setItemQty={mgr.setItemQty}
// //                   removeDraftItem={mgr.removeDraftItem}
// //                   addDraftItem={mgr.addDraftItem}
// //                   saveItems={mgr.saveItems}
// //                 />
// //               );
// //             })}

// //             {mgr.paged.length === 0 && (
// //               <tr>
// //                 <td colSpan={11} style={{ padding: 16, textAlign: "center" }}>
// //                   Замовлень не знайдено
// //                 </td>
// //               </tr>
// //             )}
// //           </tbody>
// //         </table>
// //       </div>

// //       {/* PAGINATION (в цьому файлі, без окремого компоненту) */}
// //       <div className={styles.paginator}>
// //         <button
// //           className={styles.pageBtn}
// //           onClick={() => mgr.goto(1)}
// //           disabled={mgr.pageClamped === 1}
// //         >
// //           « Перша
// //         </button>

// //         <button
// //           className={styles.pageBtn}
// //           onClick={() => mgr.goto(mgr.pageClamped - 1)}
// //           disabled={mgr.pageClamped === 1}
// //         >
// //           ‹ Назад
// //         </button>

// //         <span className={styles.pageInfo}>
// //           Сторінка {mgr.pageClamped} з {mgr.totalPages}
// //         </span>

// //         <button
// //           className={styles.pageBtn}
// //           onClick={() => mgr.goto(mgr.pageClamped + 1)}
// //           disabled={mgr.pageClamped === mgr.totalPages}
// //         >
// //           Вперед ›
// //         </button>

// //         <button
// //           className={styles.pageBtn}
// //           onClick={() => mgr.goto(mgr.totalPages)}
// //           disabled={mgr.pageClamped === mgr.totalPages}
// //         >
// //           Остання »
// //         </button>
// //       </div>
// //     </div>
// //   );
// // }
// import React, { useEffect } from "react";
// import { useNavigate, useParams } from "react-router-dom";
// import styles from "./OrderList.module.css";

// import { PAGE_SIZES } from "./OrderListFile/constants";
// import { useOrdersManager } from "./OrderListFile/useOrdersManager";
// import OrderRow from "./OrderListFile/OrderRow";

// export default function OrderList() {
//   const { page = "1" } = useParams();
//   const navigate = useNavigate();

//   const routePage = Math.max(1, Number(page) || 1);

//   const mgr = useOrdersManager(PAGE_SIZES[0], routePage);

//   useEffect(() => {
//     if (!mgr.isLoaded) return;

//     const nextPage = Math.max(1, Number(routePage) || 1);

//     if (nextPage > mgr.totalPages) {
//       navigate(`/adm/order/${mgr.totalPages}`, { replace: true });
//       return;
//     }

//     if (nextPage < 1) {
//       navigate("/adm/order/1", { replace: true });
//     }
//   }, [mgr.isLoaded, mgr.totalPages, routePage, navigate]);

//   const goToPage = (nextPage) => {
//     navigate(`/adm/order/${nextPage}`);
//   };
//   console.log("mgr", mgr);

//   return (
//     <div className={styles.page}>
//       <div className={styles.toolbar}>
//         <h2 className={styles.title}>Замовлення</h2>

//         <div className={styles.controls}>
//           <label className={styles.control}>
//             <span>Період: з</span>
//             <input
//               type="date"
//               value={mgr.dateFrom}
//               onChange={(e) => mgr.setDateFrom(e.target.value)}
//               className={styles.input}
//             />
//           </label>

//           <label className={styles.control}>
//             <span>до</span>
//             <input
//               type="date"
//               value={mgr.dateTo}
//               onChange={(e) => mgr.setDateTo(e.target.value)}
//               className={styles.input}
//             />
//           </label>

//           <label className={styles.control}>
//             <span>Дата:</span>
//             <select
//               value={mgr.sortDir}
//               onChange={(e) => mgr.setSortDir(e.target.value)}
//               className={styles.select}
//             >
//               <option value="desc">спадання (нові зверху)</option>
//               <option value="asc">зростання (старі зверху)</option>
//             </select>
//           </label>

//           <label className={styles.control}>
//             <span>Статус вгорі:</span>
//             <select
//               value={mgr.statusPin}
//               onChange={(e) => mgr.setStatusPin(e.target.value)}
//               className={styles.select}
//             >
//               <option value="Усі">Усі</option>
//               {mgr.STATUS_OPTIONS.map((s) => (
//                 <option key={s} value={s}>
//                   {s}
//                 </option>
//               ))}
//             </select>
//           </label>

//           <label className={styles.controlCheck}>
//             <input
//               type="checkbox"
//               checked={mgr.statusOnly}
//               onChange={(e) => mgr.setStatusOnly(e.target.checked)}
//             />
//             <span>Показувати лише цей статус</span>
//           </label>

//           <label className={styles.control}>
//             <span>На сторінці:</span>
//             <select
//               value={mgr.pageSize}
//               onChange={(e) => mgr.setPageSize(Number(e.target.value))}
//               className={styles.select}
//             >
//               {PAGE_SIZES.map((n) => (
//                 <option key={n} value={n}>
//                   {n}
//                 </option>
//               ))}
//             </select>
//           </label>
//         </div>
//       </div>

//       <div className={styles.tableWrap}>
//         <table className={styles.table}>
//           <thead>
//             <tr>
//               <th className={styles.colCheck}></th>
//               <th>Дата створення</th>
//               <th>ID</th>
//               <th>Покупець</th>
//               <th>Статус</th>
//               <th>Оплата</th>
//               <th>Рахунок</th>
//               <th>Оплачено</th>
//               <th>Скасовано</th>
//               <th className={styles.colSum}>Сума</th>
//               <th>Позиції</th>
//             </tr>
//           </thead>

//           <tbody>
//             {mgr.paged.map((row) => {
//               const id = row.order.id;
//               const isOpen = !!mgr.expanded[id];

//               return (
//                 <OrderRow
//                   key={id}
//                   styles={styles}
//                   row={row}
//                   isOpen={isOpen}
//                   toggleExpand={mgr.toggleExpand}
//                   editingStatusId={mgr.editingStatusId}
//                   statusDraft={mgr.statusDraft}
//                   setStatusDraft={mgr.setStatusDraft}
//                   beginEditStatus={mgr.beginEditStatus}
//                   saveStatus={mgr.saveStatus}
//                   onStatusKey={mgr.onStatusKey}
//                   statusOptions={mgr.STATUS_OPTIONS}
//                   editingTtnId={mgr.editingTtnId}
//                   ttnDraft={mgr.ttnDraft}
//                   setTtnDraft={mgr.setTtnDraft}
//                   beginEditTTN={mgr.beginEditTTN}
//                   saveTTN={mgr.saveTTN}
//                   saveTTNAndSetStatus={mgr.saveTTNAndSetStatus}
//                   cancelEditTTN={mgr.cancelEditTTN}
//                   onTtnKey={mgr.onTtnKey}
//                   editingItemsId={mgr.editingItemsId}
//                   itemsDraft={mgr.itemsDraft}
//                   newPid={mgr.newPid}
//                   setNewPid={mgr.setNewPid}
//                   newQty={mgr.newQty}
//                   setNewQty={mgr.setNewQty}
//                   savingItems={mgr.savingItems}
//                   beginEditItems={mgr.beginEditItems}
//                   cancelEditItems={mgr.cancelEditItems}
//                   setItemQty={mgr.setItemQty}
//                   removeDraftItem={mgr.removeDraftItem}
//                   addDraftItem={mgr.addDraftItem}
//                   saveItems={mgr.saveItems}
//                 />
//               );
//             })}

//             {mgr.paged.length === 0 && (
//               <tr>
//                 <td colSpan={11} style={{ padding: 16, textAlign: "center" }}>
//                   Замовлень не знайдено
//                 </td>
//               </tr>
//             )}
//           </tbody>
//         </table>
//       </div>

//       <div className={styles.paginator}>
//         <button
//           className={styles.pageBtn}
//           onClick={() => goToPage(1)}
//           disabled={mgr.pageClamped === 1}
//         >
//           « Перша
//         </button>

//         <button
//           className={styles.pageBtn}
//           onClick={() => goToPage(mgr.pageClamped - 1)}
//           disabled={mgr.pageClamped === 1}
//         >
//           ‹ Назад
//         </button>

//         <span className={styles.pageInfo}>
//           Сторінка {mgr.pageClamped} з {mgr.totalPages}
//         </span>

//         <button
//           className={styles.pageBtn}
//           onClick={() => goToPage(mgr.pageClamped + 1)}
//           disabled={mgr.pageClamped === mgr.totalPages}
//         >
//           Вперед ›
//         </button>

//         <button
//           className={styles.pageBtn}
//           onClick={() => goToPage(mgr.totalPages)}
//           disabled={mgr.pageClamped === mgr.totalPages}
//         >
//           Остання »
//         </button>
//       </div>
//     </div>
//   );
// }
import React, { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import styles from "./OrderList.module.css";

import { PAGE_SIZES } from "./OrderListFile/constants";
import { useOrdersManager } from "./OrderListFile/useOrdersManager";
import OrderRow from "./OrderListFile/OrderRow";

export default function OrderList() {
  const { page = "1" } = useParams();
  const navigate = useNavigate();

  const routePage = Math.max(1, Number(page) || 1);

  const mgr = useOrdersManager(PAGE_SIZES[0], routePage);

  useEffect(() => {
    if (!mgr.isLoaded) return;

    const nextPage = Math.max(1, Number(routePage) || 1);

    if (nextPage > mgr.totalPages) {
      navigate(`/adm/order/${mgr.totalPages}`, { replace: true });
      return;
    }

    if (nextPage < 1) {
      navigate("/adm/order/1", { replace: true });
    }
  }, [mgr.isLoaded, mgr.totalPages, routePage, navigate]);

  const goToPage = (nextPage) => {
    navigate(`/adm/order/${nextPage}`);
  };

  return (
    <div className={styles.page}>
      <div className={styles.toolbar}>
        <h2 className={styles.title}>Замовлення</h2>

        <div className={styles.controls}>
          <label className={styles.control}>
            <span>Період: з</span>
            <input
              type="date"
              value={mgr.dateFrom}
              onChange={(e) => mgr.setDateFrom(e.target.value)}
              className={styles.input}
            />
          </label>

          <label className={styles.control}>
            <span>до</span>
            <input
              type="date"
              value={mgr.dateTo}
              onChange={(e) => mgr.setDateTo(e.target.value)}
              className={styles.input}
            />
          </label>

          <label className={styles.control}>
            <span>Дата:</span>
            <select
              value={mgr.sortDir}
              onChange={(e) => mgr.setSortDir(e.target.value)}
              className={styles.select}
            >
              <option value="desc">спадання (нові зверху)</option>
              <option value="asc">зростання (старі зверху)</option>
            </select>
          </label>

          <label className={styles.control}>
            <span>Категорія:</span>
            <select
              value={mgr.categoryFilter}
              onChange={(e) => mgr.setCategoryFilter(e.target.value)}
              className={styles.select}
            >
              <option value="Усі">Усі</option>
              {mgr.ROLE_OPTIONS.map((role) => (
                <option key={role} value={role}>
                  {role}
                </option>
              ))}
            </select>
          </label>

          <label className={styles.controlCheck}>
            <input
              type="checkbox"
              checked={mgr.categorySort}
              onChange={(e) => mgr.setCategorySort(e.target.checked)}
            />
            <span>Групувати по категорії</span>
          </label>

          <label className={styles.control}>
            <span>Статус вгорі:</span>
            <select
              value={mgr.statusPin}
              onChange={(e) => mgr.setStatusPin(e.target.value)}
              className={styles.select}
            >
              <option value="Усі">Усі</option>
              {mgr.STATUS_OPTIONS.map((s) => (
                <option key={s} value={s}>
                  {s}
                </option>
              ))}
            </select>
          </label>

          <label className={styles.controlCheck}>
            <input
              type="checkbox"
              checked={mgr.statusOnly}
              onChange={(e) => mgr.setStatusOnly(e.target.checked)}
            />
            <span>Показувати лише цей статус</span>
          </label>

          <label className={styles.control}>
            <span>На сторінці:</span>
            <select
              value={mgr.pageSize}
              onChange={(e) => mgr.setPageSize(Number(e.target.value))}
              className={styles.select}
            >
              {PAGE_SIZES.map((n) => (
                <option key={n} value={n}>
                  {n}
                </option>
              ))}
            </select>
          </label>
        </div>
      </div>

      <div className={styles.tableWrap}>
        <table className={styles.table}>
          <thead>
            <tr>
              <th className={styles.colCheck}></th>
              <th>Дата створення</th>
              <th>ID</th>
              <th>Покупець</th>
              <th>Статус</th>
              <th>Оплата</th>
              <th>Рахунок</th>
              <th>Оплачено</th>
              <th>Скасовано</th>
              <th className={styles.colSum}>Сума</th>
              <th>Позиції</th>
            </tr>
          </thead>

          <tbody>
            {mgr.paged.map((row) => {
              const id = row.order.id;
              const isOpen = !!mgr.expanded[id];

              return (
                <OrderRow
                  key={id}
                  styles={styles}
                  row={row}
                  isOpen={isOpen}
                  toggleExpand={mgr.toggleExpand}
                  editingStatusId={mgr.editingStatusId}
                  statusDraft={mgr.statusDraft}
                  setStatusDraft={mgr.setStatusDraft}
                  beginEditStatus={mgr.beginEditStatus}
                  saveStatus={mgr.saveStatus}
                  onStatusKey={mgr.onStatusKey}
                  statusOptions={mgr.STATUS_OPTIONS}
                  editingTtnId={mgr.editingTtnId}
                  ttnDraft={mgr.ttnDraft}
                  setTtnDraft={mgr.setTtnDraft}
                  beginEditTTN={mgr.beginEditTTN}
                  saveTTN={mgr.saveTTN}
                  saveTTNAndSetStatus={mgr.saveTTNAndSetStatus}
                  cancelEditTTN={mgr.cancelEditTTN}
                  onTtnKey={mgr.onTtnKey}
                  editingItemsId={mgr.editingItemsId}
                  itemsDraft={mgr.itemsDraft}
                  newPid={mgr.newPid}
                  setNewPid={mgr.setNewPid}
                  newQty={mgr.newQty}
                  setNewQty={mgr.setNewQty}
                  savingItems={mgr.savingItems}
                  beginEditItems={mgr.beginEditItems}
                  cancelEditItems={mgr.cancelEditItems}
                  setItemQty={mgr.setItemQty}
                  removeDraftItem={mgr.removeDraftItem}
                  addDraftItem={mgr.addDraftItem}
                  saveItems={mgr.saveItems}
                />
              );
            })}

            {mgr.paged.length === 0 && (
              <tr>
                <td colSpan={11} style={{ padding: 16, textAlign: "center" }}>
                  Замовлень не знайдено
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      <div className={styles.paginator}>
        <button
          className={styles.pageBtn}
          onClick={() => goToPage(1)}
          disabled={mgr.pageClamped === 1}
        >
          « Перша
        </button>

        <button
          className={styles.pageBtn}
          onClick={() => goToPage(mgr.pageClamped - 1)}
          disabled={mgr.pageClamped === 1}
        >
          ‹ Назад
        </button>

        <span className={styles.pageInfo}>
          Сторінка {mgr.pageClamped} з {mgr.totalPages}
        </span>

        <button
          className={styles.pageBtn}
          onClick={() => goToPage(mgr.pageClamped + 1)}
          disabled={mgr.pageClamped === mgr.totalPages}
        >
          Вперед ›
        </button>

        <button
          className={styles.pageBtn}
          onClick={() => goToPage(mgr.totalPages)}
          disabled={mgr.pageClamped === mgr.totalPages}
        >
          Остання »
        </button>
      </div>
    </div>
  );
}
